import { useEffect, useState } from 'react';
import { MessageSquare, Pause, Play, Sparkles, Target, Trophy } from 'lucide-react';

const stages = [
  { label: 'Set context', note: 'Give only the background needed to understand the challenge.', icon: MessageSquare },
  { label: 'Name the goal', note: 'Make your responsibility, constraints, and success measure explicit.', icon: Target },
  { label: 'Show decisions', note: 'Focus on what you chose, why, and how you worked with others.', icon: Sparkles },
  { label: 'Land the result', note: 'Close with measurable impact and what you learned.', icon: Trophy },
];

export function RehearsalFlow() {
  const [step, setStep] = useState(0);
  const [playing, setPlaying] = useState(false);
  useEffect(() => {
    if (!playing) return;
    const timer = window.setTimeout(() => step < stages.length - 1 ? setStep(step + 1) : setPlaying(false), 1500);
    return () => window.clearTimeout(timer);
  }, [playing, step]);
  return <div className="rehearsal-flow"><div className="rehearsal-track">{stages.map(({ label, icon: Icon }, index) => <button className={index <= step ? 'active' : ''} onClick={() => { setStep(index); setPlaying(false); }} key={label}><span><Icon /></span><b>{label}</b>{index < stages.length - 1 && <i />}</button>)}</div><div className="rehearsal-note"><span>0{step + 1}</span><p>{stages[step].note}</p><button className="play-button" onClick={() => { if (step === stages.length - 1) setStep(0); setPlaying(!playing); }}>{playing ? <Pause /> : <Play fill="currentColor" />}{playing ? 'Pause' : 'Play answer structure'}</button></div></div>;
}

